// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-expansion-panel-header[data-v-7ddb054f]{color:#fff}.display-wheel[data-v-7ddb054f]{display:flex!important;justify-content:flex-start;align-items:baseline}.v-btn--disabled[data-v-7ddb054f]{color:blue}.schema-text[data-v-7ddb054f]{font-size:10px}.wheel[data-v-7ddb054f]{position:absolute;height:150px;width:300px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
